<template>
<el-collapse-item :name="item.id">
    <template slot="title">
      <div class="row pad-in">
        <div class="col s11">{{ item.cognome }}&#160;{{ item.nome }}</div>
        <!--
        <div class="col s2 yo-align-left">{{item.id}}</div>
        <div class="col s1 red yo-text-bold yo-align-right" v-if="item.nr_numero>10" style="">{{item.nr_numero}}&#160;&#160;<i class="material-icons" style="float:right;margin-right:12px;line-height:48px;">error</i></div>
        <div class="col s1 tree_poppy yo-text-bold yo-align-right" v-if="item.nr_numero>0 && item.nr_numero<11" style="">{{item.nr_numero}}&#160;&#160;<i class="material-icons" style="float:right;margin-right:12px;line-height:48px;">warning</i></div>
        <div class="col s1 grees yo-text-bold yo-align-right" v-if="item.nr_numero==0" style=""><i class="material-icons" style="float:right;margin-right:12px;line-height:48px;">done</i></div>
         -->
      </div>
    </template>
    
    <div class="row pad-in">
      <div class="col s12" v-html="affiliazionesupiurighe"></div>
      <div class="col s12 m3 offset-m9 yo-align-right"  v-on:click="addAbsautore()"><el-button type="primary" style="width:100%;" >ADD AS ABSTRACT AUTHOR</el-button></div>
   </div>



</el-collapse-item>
</template>


<script>
import dbItem from '../teras/dbItem'
export default {
  name: 'item-elenco',
  created () {
    this.$teras.pageHeader = 80
  },
  mounted () {
    this.$emit('scrollTop', 0)
  },
  props: {
    item: Object
  },
   methods: {
      async addAbsautore(scheda) {
         console.log("Provo a salvare abstract_autore")
         let absAutore = new dbItem({table:'abstract_autore'})
         await absAutore.new()
         absAutore.row.autore = this.item.id
         absAutore.row.abstract = this.$abstract.profile.row.id
         absAutore.row.numero = this.$abstract._autore.length+1
         let primo = await this.$axios.query('fetchOne',`SELECT COUNT(*) FROM abstract_autore WHERE primo=1 AND abstract=←abstract`,{abstract: this.$abstract.profile.row.id})
         if(primo.result==0){
            absAutore.row.primo = 1
         }
         console.log(absAutore.row)
         await absAutore.save()
         this.$emit('absautoreAdded', this.item)
      }
   },
   computed: {
      affiliazionesupiurighe:function() {
         return this.item.affiliazione.replace(/(?:\r\n|\r|\n)/g, '<br>')
      }
   }
}
</script>

<style>
</style>
